export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        resources: action.resources,
      };
    case 'ADD':
      return {
        ...state,
        resources: [...state.resources, action.resource].sort((a, b) => {
          const titleA = a.attributes.title;
          const titleB = b.attributes.title;
          if (titleA < titleB) {
            return -1;
          }
          if (titleA > titleB) {
            return 1;
          }
          return 0;
        }),
      };
    case 'UPDATE':
      return {
        ...state,
        resources: state.resources
          .map((item) => (item.id === action.resource.id ? action.resource : item))
          .sort((a, b) => {
            const titleA = a.attributes.title;
            const titleB = b.attributes.title;
            if (titleA < titleB) {
              return -1;
            }
            if (titleA > titleB) {
              return 1;
            }
            return 0;
          }),
      };
    case 'DELETE':
      return {
        ...state,
        resources: state.resources
          .filter((item) => (item.id !== action.resourceId)),
      };
    default:
      throw new Error();
  }
}
